import React from 'react';
import {useGlobalState} from "../../../App";
import _ from "lodash";
import {getFormAttribute} from "../../../utils/form";
import {Tab, Tabs} from "react-bootstrap";
import FormItem from 'components/form/form_item';
import Receipt from "./receipt";


function Receipts(props: {
    process_id: number,
    real_estate_id: number,
} = {
    process_id: 0,
    real_estate_id: 0,
}) {
    const [form_data] = useGlobalState('form');

    const field = 'islem' + props.process_id + '_t' + props.real_estate_id + '-dekontSayisi'
    const dekont_sayisi = getFormAttribute(form_data, field)

    return (
        <>
            <FormItem type="number" label={"Dekont Sayısı"} humanRef={"D000S"} name={field} attributes={{'max': 20}}/>
            <br/>

            {dekont_sayisi['value'] &&
                <Tabs
                    defaultActiveKey={'islem' + props.process_id + '_tasinmaz' + props.real_estate_id + '_satici0'}
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                    {_.times(dekont_sayisi['value'], (i: number) => (
                        <Tab key={i} eventKey={'islem' + props.process_id + '_tasinmaz' + props.real_estate_id + '_satici' + i} title={(i + 1) + '. Dekont'}>
                            <Receipt key={i} process_id={props.process_id} real_estate_id={props.real_estate_id} receipt_id={i + 1}/>
                        </Tab>
                    ))}
                </Tabs>}
        </>
    );
}

export default Receipts;
